import { AnyAction, createAsyncThunk, ThunkDispatch } from '@reduxjs/toolkit';
import { records as appStorageRecords } from '@saucelabs/sl-module-app-storage';
import { actions as notificationsActions } from '@saucelabs/sl-container-notifications';

import { GlobalState } from '../../reducers';
import { actions as rdcSessionActions, RdcAppInstallationResponse } from '../rdcSession';
import { RDC_DEVICE_RESPONSE_STATUS } from '../../constants';
import types from './types';

const handleInstallAppResponse = (
  result: RdcAppInstallationResponse,
  file: appStorageRecords.AppStorageFile,
  dispatch: ThunkDispatch<unknown, unknown, AnyAction>,
) => {
  if (result.status === RDC_DEVICE_RESPONSE_STATUS.ERROR) {
    throw new Error(result.error);
  }

  if (result.status === RDC_DEVICE_RESPONSE_STATUS.FINISHED) {
    dispatch(notificationsActions.notifySuccess(
      file.getDisplayName(), 'Successfully installed', false, undefined, true,
    ));
  }

  return result;
};

const installMobileAppDependency = createAsyncThunk(
  types.INSTALL_APP,
  async (
    file: appStorageRecords.AppStorageFile,
    { dispatch, getState, rejectWithValue, signal },
  ) => {
    const { apps: { manual: { session } } } = getState() as GlobalState;
    const device = session.get('device') as any; // eslint-disable-line @typescript-eslint/no-explicit-any

    try {
      let appInstallationResult = await device.installAppFromAppStorage(
        file.id, file.group_id, false,
      ) as RdcAppInstallationResponse;

      handleInstallAppResponse(appInstallationResult, file, dispatch);

      if (appInstallationResult.status === RDC_DEVICE_RESPONSE_STATUS.PENDING) {
        appInstallationResult = await rdcSessionActions.pollAppInstallationStatus(
          device, appInstallationResult.id, signal,
        );

        handleInstallAppResponse(appInstallationResult, file, dispatch);
      }

      return appInstallationResult;
    } catch (error: any) { // eslint-disable-line @typescript-eslint/no-explicit-any
      dispatch(notificationsActions.notifyDanger(
        error.message, `Failed to install ${file.getDisplayName()}`, true, undefined, true,
      ));

      return rejectWithValue(error.message);
    }
  },
);

export default {
  installMobileAppDependency,
};
